import axios from "infra/http";
import { useQuery } from "react-query";
import { FornecedorTributacao } from 'core/features/fornecedores/typings/index';

function useGetTributacao(id?: string) {
    return useQuery(
        `/v1/fornecedor/${id}/tributacao`,
        async () => {
            const res = await axios.get<FornecedorTributacao>(`/v1/fornecedor/${id}/tributacao`);

            return res.data;
        },
        {
            enabled: !!id,
        }
    );
}

export default useGetTributacao;
